import { render, staticRenderFns } from "./NodeForm.vue?vue&type=template&id=2ddb0774&scoped=true"
import script from "./NodeForm.vue?vue&type=script&lang=js"
export * from "./NodeForm.vue?vue&type=script&lang=js"
import style0 from "./NodeForm.vue?vue&type=style&index=0&id=2ddb0774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddb0774",
  null
  
)

export default component.exports